module.exports = __webpack_public_path__ + "static/casa3-81c3f51d2b42b2a050c13d683426c56a.png";